<!-- Desktop Version -->

<div class="d-none d-lg-block">
    <div class="row">
        <div class="col-6 col-md-2">
            <a href="https://resmac.com"> <img src="assets/images/resmac_logo.svg" width="150" height="150" alt="Resmac Logo" class="img-responsive" style="padding-top: 5px;"></a>
        </div>
        <div class="col-4 col-md-8"></div>
        <div class="col-2 col-md-2">
            <br><br>
            <ul class="nav ml-auto text-right">

                <li class="nav-item">
                    <a class="nav-link pt-3" href="tel:8665363459">
                        <nb-icon style="color: #8f9bb3; font-size: 1.35rem; display: block" icon="phone-outline"></nb-icon>
                        <span style="display: inline-block; font-size: 10px; color: #8f9bb3;">Call</span>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link pt-3" href="mailto:info@lendingman.com">
                        <nb-icon style="color: #8f9bb3; font-size: 1.35rem; display: block" icon="email-outline"></nb-icon>
                        <span style="display: inline-block; font-size: 10px; color: #8f9bb3;">Mail</span>
                    </a>

                </li>
            </ul>
        </div>



    </div>



</div>



<!-- Mobile Version -->

<div class="row d-lg-none">
    <div class="navbar-brand minimum">
        <a href="https://resmac.com"><img src="assets/images/resmac_logo.svg" width="60" height="60" alt="Resmac Mobile Logo"></a>
    </div>

    <ul class="nav ml-auto">

        <li class="nav-item">
            <a class="nav-link pt-3" href="tel:8665363459">
                <nb-icon style="color: #8f9bb3; font-size: 1.35rem; display: block" icon="phone-outline"></nb-icon>
                <span style="display: inline-block; font-size: 10px; color: #8f9bb3;">Call</span>
            </a>
        </li>

        <li class="nav-item">
            <a class="nav-link pt-3" href="mailto:info@lendingman.com">
                <nb-icon style="color: #8f9bb3; font-size: 1.35rem; display: block" icon="email-outline"></nb-icon>
                <span style="display: inline-block; font-size: 10px; color: #8f9bb3;">Mail</span>
            </a>

        </li>
    </ul>




</div>
